import { api } from './client';

export interface CollectionLink {
  id: string;
  /** 完整的对外链接，直接发给对方即可。 */
  url: string;
  title: string;
  requireEmailVerification: boolean;
  /** 创建人指定的收件邮箱；验证码只发这个地址。 */
  requiredEmail: string | null;
  currency: string | null;
  status: 'PENDING' | 'FILLED' | 'REVOKED';
  expiresAt: string;
  filledAt: string | null;
  /** 走了邮箱验证的话，是验证过的那个邮箱。 */
  verifiedEmail: string | null;
  payeeId: string | null;
  payeeName: string | null;
  createdByName: string | null;
  createdAt: string;
}

export interface CollectionLinkFilter {
  keyword?: string;
  status?: CollectionLink['status'][];
  /** 有效性只对「待填写」的链接有意义：已填写 / 已作废的不存在「过期」这回事。 */
  validity?: 'ACTIVE' | 'EXPIRED';
  requireEmailVerification?: boolean;
  createdFrom?: string;
  createdTo?: string;
}

export async function listCollectionLinks(filter: CollectionLinkFilter = {}) {
  const { data } = await api.post<{ items: CollectionLink[] }>('/collection-links/list', filter);
  return data.items;
}

export async function createCollectionLink(input: {
  title: string;
  requireEmailVerification: boolean;
  /** 开了邮箱验证时必填。 */
  requiredEmail?: string;
  currency?: string;
  ttlDays?: number;
}) {
  const { data } = await api.post<CollectionLink>('/collection-links/create', input);
  return data;
}

export async function revokeCollectionLink(id: string) {
  const { data } = await api.post<{ ok: true }>('/collection-links/revoke', { id });
  return data;
}
